import "leaflet/dist/leaflet.css";
import L from "leaflet";
// import icon from '../assets/icons/place_red_24dp.svg';
import {state, getItemAnnuaire, wpApiSettings} from "../store";
import 'leaflet.markercluster';
import {getCoordsCity} from "./apiGouv";

class Map {

    constructor(myMap, marker, markers) {
        this.myMap = myMap;
        this.marker = marker;
        this.markers = markers;
        this.markerClusterGroup = L.markerClusterGroup()
    }

    buildMap() {
        // Openstreet map
        // const tiles = L.tileLayer(
        //     'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        //     {
        //         maxZoom: 18,
        //         attribution:
        //             '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        //     }
        // );

        // Mapbox
        const tiles = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmVuamFtaW5tdGgiLCJhIjoiY2t0aWtjbGl4MTJzejJ2anltaDNrbWp1NiJ9.jk8rl_a8DFfjmNeRjB0-ig', {
            attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            tileSize: 512,
            zoomOffset: -1
        });

        this.myMap = L.map('map', {
            center: [46.227638, 2.213749],
            zoom: 5,
            layers: [tiles],
        });

        this.myMap.on('popupopen', (e) => {
            this.myMap.flyTo(e.target._popup._latlng, 16);
        });

        // Custom marker
        let DefaultIcon = L.icon({
            iconUrl: `${wpApiSettings.uploads}/marker.svg`,
            iconSize: [50, 95]
        });
        L.Marker.prototype.options.icon = DefaultIcon;
    }

    initMap() {
        this.myMap = null;
    }

    async getMap() {

        if (!this.myMap) {
            this.buildMap();
        } else {
            this.markerClusterGroup.removeLayers(this.markers);
        }

        this.placeMarkers();
    }

    async centerViewOnCity() {
        const coords = await getCoordsCity(state.query.city);
        this.myMap.setView([coords.lat, coords.lon], 12);
    }

    centerView() {
        this.myMap.setView([46.227638, 2.213749], 5);
    }

    placeMarkers() {
        this.markers = [];
        const positions = state.positions;

        positions.forEach(position => {
            if (position.latitude && position.longitude) {
                let marker = new L.marker([position.latitude, position.longitude]);

                marker.addEventListener("click", async () => {
                    const item = position.annuaire;
                    state.displayedAnnuaire.unshift(item);

                    let aTel = "";
                    if (item.publication_numero == 1) {
                        aTel = `<p>Téléphone: <a href="tel:${item.tel}">${item.tel}</a ></p>`
                    }

                    let aWebsite = "";
                    if (item.site_internet) {
                        aWebsite = `<p>Site web: <a href="${item.site_internet}" target="_blank">${item.site_internet}</a></p>`;
                    }

                    // Ajout popup
                    marker.bindPopup(`
                <div class="popup">
                    <div style="text-align: center; font-size: 16px">
                        <b>${item.user.display_name}</b>
                    </div>
                    <div class="popup-details">
                        <p>Adresse: ${item.adresse_cabinet}, ${item.code_postal_cabinet} ${item.ville_cabinet}</p>
                        <p>Email: <a href="mailto:${item.email}">${item.email}</a ></p>
                        ${aTel}
                        ${aWebsite}
                    </div>
                    <div style="margin: 0 auto">
                        <a href="${wpApiSettings.url}/suph/profil?id=${item.id}" target="_blank">Plus d'informations</a>
                    </div>
                </div > `).openPopup();
                });
                this.markers.push(marker);

            }

        })


        this.markerClusterGroup.addLayers(this.markers);
        this.myMap.addLayer(this.markerClusterGroup);
    }
}

export default new Map;